export const mutations = {
    setGradeProduto(state, payload){
        state.gradeProduto = {...payload}
    },
    setGradesProduto(state, payload){
        state.gradesProduto = payload
    },
    setModalCadastroGradeProduto(state, status){
        state.modalCadastroGradeProduto = status
    },
    setModalExcluirGradeProduto(state, status){
        state.modalExcluirGradeProduto = status
    },
    setModalListarGradeProduto(state, status){
        state.modalListarGradeProduto = status
    }
}

export default {}